import css from "styled-jsx/css";

export const componentStyles = css`
  .monday-demo-tabs-asset-wrapper {
    position: relative;
    max-width: 900px;
    width: 900px;
    max-height: 680px;
    height: 680px;
  }
`;
